import { Select } from '@kc-console/common-ui';
import { useTranslation } from '@kc-console/core';

import { DEFAULT_PAGE_SIZE_OPTIONS } from '../DataTable';

export interface ActionBarSettingsPageSizeSelectProps {
  onPageSizeChange: (pageSize: number) => void;
  pageSize: number;
  pageSizeOptions?: number[];
}

export default function ActionBarSettingsPageSizeSelect(
  props: ActionBarSettingsPageSizeSelectProps,
) {
  const { t } = useTranslation();
  const { onPageSizeChange, pageSize, pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS } = props;

  const pageSizeSelectOptions = pageSizeOptions.map(option => ({
    value: option,
    text: t('ui:settings.page_size', { pageSize: option }),
  }));

  return (
    <Select
      size="md"
      options={pageSizeSelectOptions}
      value={pageSize}
      onChange={onPageSizeChange}
    />
  );
}
